import React from "react"

import { Form, Formik } from "formik"
import * as Yup from "yup"

import { gql, useMutation } from "hooks/urql"

import {
  FormFailures,
  TextAreaField,
  handleFailure,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const ValidationSchema = Yup.object().shape({
  cancellationReason: Yup.string().required(
    "Please provide a cancellation reason"
  ),
})

const AdminCancelSessionButton = ({ id }) => {
  const initialFormState = {
    cancellationReason: "",
  }

  const [, runMutation]: any[] = useMutation(cancelSessionMutation)

  const handleSubmit = (values, actions) => {
    actions.setStatus("Submitting...")
    runMutation({ id, cancellationReason: values.cancellationReason })
      .then(
        result => {
          const { failures } = result.data.cancelSession
          if (failures.length > 0) {
            handleFailure(actions, failures)
          } else {
            window.location.reload()
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      buttonClassName="btn solid btn-danger"
      buttonText="Cancel"
      modalClassName="bootstrap-modal"
      modalTitle="Cancel Session"
    >
      {({ closeModal }) => (
        <React.Fragment>
          <Formik
            initialValues={initialFormState}
            onSubmit={(values, actions) => handleSubmit(values, actions)}
            validationSchema={ValidationSchema}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="modal-body">
                  <p>
                    Are you sure you want to cancel this session? This action is
                    not reversible.
                  </p>
                  <TextAreaField
                    label="Cancellation Reason"
                    name="cancellationReason"
                  />
                </div>
                <div className="modal-footer" style={{ flexFlow: "column" }}>
                  <FormFailures />
                  <div className="w-100 d-flex justify-content-between">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn solid red btn-danger"
                    >
                      Yes, cancel it!
                    </button>
                    <button
                      className="btn solid blue btn-info"
                      onClick={closeModal}
                    >
                      No, I'll keep it
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </React.Fragment>
      )}
    </ModalWithProvidedBody>
  )
}

const cancelSessionMutation = gql`
  mutation ($id: ID!, $cancellationReason: String!) {
    cancelSession(id: $id, cancellationReason: $cancellationReason) {
      failures {
        message
      }
    }
  }
`

export default AdminCancelSessionButton
